module.exports = __webpack_public_path__ + "img/denmark-endocrine-nutritional-metabolic-diseases-male.f2d55d1e.png";